import { useEffect } from 'react';

import { addTrailerVideo } from '../../store/slices/moviesSlice';
import { API_OPTIONS, MOVIE_URL } from '../../utils/constants';
import { VideoType } from '../../types';
import { RootState } from '../../store/appStore';
import { useAppDispatch, useAppSelector } from '../../utils/hooks';

const useMovieTrailer = (movieId: number) => {
  const dispatch = useAppDispatch();
  const trailerVideo = useAppSelector(
    (store: RootState) => store.movies.trailerVideo
  );
  const getMovieVideo = async () => {
    const movieData = await fetch(`${MOVIE_URL + movieId}/videos`, API_OPTIONS);
    const json = await movieData.json();
    const filterData =
      json?.results?.filter?.((video: VideoType) => video.type === 'Trailer') ||
      [];
    const trailer =
      filterData.length === 0
        ? json?.results?.[0]
        : filterData[filterData.length - 1];
    dispatch(addTrailerVideo(trailer));
  };
  useEffect(() => {
    !trailerVideo && getMovieVideo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useMovieTrailer;
